import api from "../../shared/api";

export default {
  namespaced: true,
  state: () => ({
    themes: [],
    selectedTheme: null,
  }),
  actions: {
    getThemes({ state }, data) {
      api.get(
        "themes",
        (result) => {
          state.themes = result.data.themes;
          state.selectedTheme = result.data.selectedTheme;
          if (data && data.onSuccess) data.onSuccess(result);
        },
        (error) => {
          if (data && data.onError) data.onError(error);
        },
        () => {
          if (data && data.onFinish) data.onFinish();
        }
      );
    },
    importThemeData({ state }, data) {
      api.post(
        "themes/import",
        { ...data },
        (result) => {
          if (data && data.onSuccess) data.onSuccess(result);
        },
        (error) => {
          if (data && data.onError) data.onError(error);
        },
        () => {
          if (data && data.onFinish) data.onFinish();
        }
      );
    },
  },
};
